import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectApkData } from '../store/slices/mobileBillingAppSlice';
import { countByStatus } from './apkStatus';
import './Mobilebillingapp.css';

// Fetching lives in MobilebillingappContent, which owns the client/branch filters that
// decide what to fetch — dispatching here too would just double every request. The tiles
// read the same slice, so they describe whatever the filters are currently showing.
const MobilebillingappHeader = () => {
    const apkData = useSelector(selectApkData);

    const stats = useMemo(
        () => ({
            active: countByStatus(apkData, 'Active'),
            inactive: countByStatus(apkData, 'Inactive'),
            total: apkData.length,
            play: apkData.filter((a) => String(a.play_storelink || '').trim()).length,
            drive: apkData.filter((a) => String(a.googledrive_link || '').trim()).length
        }),
        [apkData]
    );

    return (
        <div className="mba-hero">
            <div className="mba-hero-main">
                <div className="mba-hero-icon">
                    <i className="pi pi-mobile" />
                </div>
                <div>
                    <h2 className="mba-hero-title">Mobile Billing App</h2>
                    <p className="mba-hero-sub">
                        The APK register for the mobile billing app. Keep each client&apos;s Play Store listing and Google Drive backup in one place, download a build directly, or email the
                        install links to whoever asks for them.
                    </p>
                </div>
            </div>

            <div className="mba-stats">
                <div className="mba-stat ok">
                    <div className="mba-stat-value">
                        <i className="pi pi-check-circle" />
                        {stats.active}
                    </div>
                    <div className="mba-stat-label">Active</div>
                </div>
                <div className="mba-stat err">
                    <div className="mba-stat-value">
                        <i className="pi pi-times-circle" />
                        {stats.inactive}
                    </div>
                    <div className="mba-stat-label">Inactive</div>
                </div>
                <div className="mba-stat play">
                    <div className="mba-stat-value">
                        <i className="pi pi-google" />
                        {stats.play}
                    </div>
                    <div className="mba-stat-label">Play Store</div>
                </div>
                <div className="mba-stat drive">
                    <div className="mba-stat-value">
                        <i className="pi pi-cloud-download" />
                        {stats.drive}
                    </div>
                    <div className="mba-stat-label">Drive Builds</div>
                </div>
                <div className="mba-stat all">
                    <div className="mba-stat-value">
                        <i className="pi pi-bolt" />
                        {stats.total}
                    </div>
                    <div className="mba-stat-label">Total</div>
                </div>
            </div>
        </div>
    );
};

export default MobilebillingappHeader;
